module.exports = __webpack_public_path__ + "static/media/document-duplicate.37098264.svg";